import { createFileRoute, redirect } from "@tanstack/react-router";
import { toast } from "sonner";
import { z } from "zod";

import { Button } from "~/components/ui/button";
import { getAuthStore } from "~/modules/auth/auth-store";
import { getAuthRedirectUrlMutation } from "~/modules/auth/network";
import { addRedirectToAuthUrl } from "~/modules/auth/utils";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  validateSearch: z.object({
    redirectTo: z.string().optional(),
  }),
  async beforeLoad() {
    const isLikelyLoggedIn = getAuthStore().getIsLikelyLoggedIn();

    if (isLikelyLoggedIn) {
      throw redirect({ to: "/home" });
    }
  },
});

function RouteComponent() {
  const { redirectTo } = Route.useSearch();

  const { mutate } = getAuthRedirectUrlMutation.useMutation({
    onSuccess(data) {
      const authUrl = addRedirectToAuthUrl(data.url, redirectTo);

      window.location.href = authUrl;
    },
    onError(error) {
      console.error(error);
      toast.error("could not login");
    },
  });

  const onClick = () => {
    mutate({ params: { callbackBaseUrl: window.location.origin } });
  };

  return (
    <main className="p-2">
      <Button onClick={onClick}>Login</Button>
    </main>
  );
}
